import {ObjectValues} from '../../../types';

export const DISPLAY_VARIANT = {
    STANDINGS: 'STANDINGS',
    FIXTURES: 'FIXTURES',
    PLAYOFF: 'PLAYOFF',
} as const

export type DisplayVariant = ObjectValues<typeof DISPLAY_VARIANT>